import { render, staticRenderFns } from "./settingsDialog.vue?vue&type=template&id=0161026d&"
import script from "./settingsDialog.vue?vue&type=script&lang=js&"
export * from "./settingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./settingsDialog.vue?vue&type=style&index=0&id=0161026d&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0161026d')) {
      api.createRecord('0161026d', component.options)
    } else {
      api.reload('0161026d', component.options)
    }
    module.hot.accept("./settingsDialog.vue?vue&type=template&id=0161026d&", function () {
      api.rerender('0161026d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/settingsDialog.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/settingsDialog.vue
// module id = x+lL
// module chunks = 0